<template>
	<div id="app">
		<!-- <keep-alive exclude=""> -->
			<router-view v-if="!platform_pc"></router-view>
			<template v-if="platform_pc">
				<div class="h5_class">
					<keep-alive exclude="resources-info,products-info,careers-apply,events-info,pdf-h5,SSB-info,contact">
						<router-view></router-view>
					</keep-alive>
				</div>
			</template>
		<!-- </keep-alive> -->
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {},
	data: function () {
		return {
			platform_pc: null,  //pc
		}
	},
	created(){
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Huawei|HONOR|OpenHarmony|HarmonyOS/i.test(navigator.userAgent) || isiPad) {
			this.platform_pc = true;
		}else {
			this.platform_pc = false;
		}
	},
	mounted() {
		// window.addEventListener('resize', this.handleResize);
	},
	methods: {
		// handleResize() {
		// 	window.location.reload();
		// }
	},
	beforeDestroy() {
		// window.removeEventListener('resize', this.handleResize);
	},
}
</script>
<style>
@charset "utf-8";
@font-face {
	font-family: 'PFFont';
	src: url('./assets/fonts/PingFang Medium.ttf');
}
@font-face {
	font-family: 'Light';
	src: url('./assets/fonts/Varta-Light.ttf');
}
@font-face {
	font-family: 'Medium';
	src: url('./assets/fonts/Varta-Medium.ttf');
}
@font-face {
	font-family: 'Regular';
	src: url('./assets/fonts/Varta-Regular.ttf');
}
::-webkit-input-placeholder{color:#999999;}
/* ::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;} */
*{/* margin:0;padding:0; */font-family: "Medium", "Helvetica", 'Arial';outline:none;text-decoration:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);touch-action: pan-y;
word-wrap: normal;letter-spacing: 0px;word-break: normal;}
img{vertical-align:top;}
html,body{
	width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling: touch;
	-webkit-text-size-adjust: 100% !important;
	/* filter: grayscale(100%); */
}
input,div,span,select,textarea,button{font-size: 16px;}
input{-webkit-appearance: none;}
.font-b{font-weight:bold;}
/* .banner_box img{
	min-width: 1308px !important;
}
.main_box{
	min-width: 1308px;
} */
a{
	color: #0B318F !important;
}

/*按钮样式*/
.btn_box_f{
	display: flex;
	justify-content: center;
}
.btn_box_ty{
	display: inline-block;
	padding: 14px 30px 8px 30px;
	font-size: 20px;
	color: #0B318F;
	border: 1px solid #0B318F;
	border-radius: 34px;
	line-height: 1;
}
.btn_box_ty img{
	width: 22px;
	position: relative;
	left: 8px;
	top: -3px;
}
a{
	color: #0B318F !important;
}
.news_box{
	position: relative;
}
.news_box .icon_left, .news_box .icon_right{
	position: absolute;
	z-index: 1;
	top: 50%;
	margin-top: -16px;
	background: #333333;
	width: 42px;
	height: 42px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.news_box .icon_left{
	left: -20px;
}
.news_box .icon_right{
	right: -20px;
}
.app_box .van-toast__text{
	color: #ffffff !important;
}
.search_box img{
	width: 100%;
}

/*loading*/
.loading{width:100%;height:100%;position:fixed;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
/*移动端展示*/
/* .h5_class{width: 100%;max-width:1440px;margin:0 auto;background-color:#ffffff;position:relative;border-left:1px solid #f5f5f5;border-right:1px solid #f5f5f5;} */

</style>